<div [formGroup]="parentForm">
	<div formGroupName="{{nestedFormGroupName}}">
		<label>{{quadrantFormGroupName.toUpperCase()}}</label>
		<div formGroupName="{{quadrantFormGroupName}}">
			<div class="grid-container bottom-border" formGroupName="{{MovementTypeFormGroupName.DISTALIZE_MESIALIZE}}">
				<mat-radio-group formControlName="option">
					<mat-radio-button value="{{AnswerOption.DISTALIZE}}" (click)="onClick(AnswerOption.DISTALIZE, MovementTypeFormGroupName.DISTALIZE_MESIALIZE)">{{ AnswerOption.DISTALIZE | translate}}</mat-radio-button>
					<mat-radio-button value="{{AnswerOption.MESIALIZE}}" (click)="onClick(AnswerOption.MESIALIZE, MovementTypeFormGroupName.DISTALIZE_MESIALIZE)">{{ AnswerOption.MESIALIZE | translate}}</mat-radio-button>
				</mat-radio-group>
				<div>
					<mat-form-field>
						<input matInput formControlName="text" data-cy="distalizeMesializeText">
						<mat-error>{{"please fill in" | translate}}</mat-error>
					</mat-form-field>
					mm
				</div>
			</div>

			<div class="grid-container" formGroupName="{{MovementTypeFormGroupName.COMPRESS_EXPAND}}">
				<mat-radio-group formControlName="option">
					<mat-radio-button value="{{AnswerOption.COMPRESS}}" (click)="onClick(AnswerOption.COMPRESS, MovementTypeFormGroupName.COMPRESS_EXPAND)">{{ AnswerOption.COMPRESS | translate}}</mat-radio-button>
					<mat-radio-button value="{{AnswerOption.EXPAND}}" (click)="onClick(AnswerOption.EXPAND, MovementTypeFormGroupName.COMPRESS_EXPAND)">{{ AnswerOption.EXPAND | translate}}</mat-radio-button>
				</mat-radio-group>
				<div>
					<mat-form-field>
						<input matInput formControlName="text" data-cy="compressExpandText">
						<mat-error>{{"please fill in" | translate}}</mat-error>
					</mat-form-field> mm
				</div>
			</div>
		</div>
	</div>
</div>
